import { useState, useEffect } from 'react';
import { useTheme } from '@emotion/react';
import { BreakpointKeys } from 'common/theme';

type useResponsiveUrlProps = {
  url?: string,
  breakpoint?: BreakpointKeys,
  desktop: number,
  mobile: number,
};

function useResponsiveUrl({ url, breakpoint = 'md', desktop, mobile }: useResponsiveUrlProps) {
  // SSR must emit a real URL so LCP/banner images are discoverable in the initial HTML.
  // Client effect then swaps to the viewport-appropriate size.
  const [newUrl, setNewUrl] = useState(() => (url ? `${url}?w=${desktop}` : ''));
  const { breakpoints } = useTheme();

  useEffect(() => {
    if (!url) {
      setNewUrl('');
      return;
    }
    if (window.innerWidth > breakpoints[breakpoint]) {
      setNewUrl(`${url}?w=${desktop}`);
    } else {
      setNewUrl(`${url}?w=${mobile}`);
    }
  }, [breakpoint, breakpoints, mobile, desktop, url]);

  return newUrl;
}

export default useResponsiveUrl;
